import { useEffect } from 'react';
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { initGA } from "./lib/ga.jsx";
import PublicApp from './PublicApp.jsx';
import DashboardApp from './DashboardApp.jsx';
import './App.css';
import { useRef } from "react";


function App() {
  const { loading, isAuthenticated, user } = useAuth();
  // const navigate = useNavigate();
  // const location = useLocation();
  // const hasRedirected = useRef(false);

  useEffect(() => {
    initGA();
  }, []);

  // useEffect(() => {
  //   if (
  //     !hasRedirected.current &&
  //     isAuthenticated &&
  //     location.pathname.endsWith("/login")
  //   ) {
  //     hasRedirected.current = true;

  //     const redirectTo = location.state?.from || "/";

  //     if (user?.role === "super_admin") {
  //       navigate("/dashboard/admin/organizations", { replace: true });
  //     } else {
  //       navigate(redirectTo, { replace: true });
  //     }
  //   }
  // }, [isAuthenticated, user, location.pathname, navigate]);



  if (loading) return null;

  return (
    <div className="app_container">
      <Routes>
        {/* Dashboard routes */}
        <Route path="/dashboard/*" element={<DashboardApp />} />
        <Route path="/organizations/*" element={<DashboardApp />} />

        {/* Everything else is public */}
        <Route path="/*" element={<PublicApp />} />
      </Routes>


    </div>
  );
}

export default App;
